export class InvalidMaxParallelError extends Error {
  readonly name = 'InvalidMaxParallelError';
  readonly message = 'maxParallel must be greater than 0';
}
